$(function() {
  'use strict';
  

  var $svg_container = $(".svg-container");
  if($svg_container.length) {
    var $svg = $svg_container.find("svg");
    var $svg_elements_on = $svg.find("[id$='_on']");
    var $svg_elements_off = $svg.find("[id$='_off']");

    

    $svg_elements_off.each(function() {
      var $svg_element = $(this);
      var $svg_element_id = $svg_element.attr("id").replace("_off", "");
      var $svg_element_on = $svg.find("[id='" + $svg_element_id + "_on']");
      
      
      $svg_element.hoverIntent(
        function() {
          $svg_elements_off.each(function() {
            if($(this).attr('id') !== $svg_element.attr('id')) {
              $(this).fadeOut(300);
            }
          });
          // $svg_element.fadeIn(300);
          $svg_element_on.fadeIn(300).attr('aria-visible', 'true');

          
        },
        function() {
          //$svg_element_on.hide();
        }
      );
      $svg_elements_off.hover(
        function() {
         
        },
        function() {
          $svg_elements_off.each(function() {
              $(this).fadeIn(400);
          });
          $svg_elements_on.fadeOut(300).attr('aria-visible', 'false');
        }
      );
      
      // $svg_element.on("tap", function() {
      //   $svg_elements_on.hide();
      //   $svg_element_on.show();
      // });

    });

  }
  if($svg_container.hasClass('amenities-svg')) {
    var $group_toggles = $('.amenities-list').find('.svg-toggle');
    $group_toggles.each(function () {
      $(this).toggleClass('active');
      var group = $(this).data('group');
      $svg.find("[id='" + group + "']").toggleClass('active');
      $(this).click(function () {
        $(this).toggleClass('active');
        var group = $(this).data('group');
        $svg.find("[id='" + group + "']").toggleClass('active');
      });
    });
  };
});


